export default __webpack_public_path__ + "images/8d75d05045012b161b039bca5e9b2ac3.png";